
import { mapActions } from 'vuex'
export default {
  name: 'RegisterPayment',
  props: {
    actionSave: {
      type: Function,
      default: () => {},
    },
    actionVolta: {
      type: Function,
      default: () => {},
    },
    value: {
      type: Object,
      default() {
        return {
          selectedOption: null,
        }
      },
    },
    returnBtn: {
      type: Boolean,
      default: true,
    },
    disabledBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingCnpj: false,
      btnCnpjSearch: false,
      rules: [(v) => !!v || 'Campo obrigatório'],
      telefoneRules: [(v) => !!v || 'O telefone é obrigatório'],
      emailRules: [
        (v) => !!v || 'O e-mail é obrigatório',
        (v) => /.+@.+\..+/.test(v) || 'E-mail deve ser válido',
      ],
    }
  },
  watch: {
    'value.cpfCnpj': function (newCpfCnpj) {
      const cpfCnpjSemCaracters = newCpfCnpj.replace(/\D/g, '')
      this.btnCnpjSearch = cpfCnpjSemCaracters.length > 12
    },
  },
  methods: {
    ...mapActions('sdagenda', ['fetchCnpj']),
    async searchCnpj() {
      this.loadingCnpj = true
      const cpfCnpjSemCaracters = this.value.cpfCnpj.replace(/\D/g, '')
      try {
        const data = await this.fetchCnpj(cpfCnpjSemCaracters)
        if (!data) {
          this.$toast.error('Não foi possível encontrar o CNPJ')
          return
        }
        this.$emit('action-fetch-cnpj', data)
      } catch (error) {
        console.error(error)
        this.$toast.error('error: ' + error.response.data.error)
      } finally {
        this.loadingCnpj = false
      }
      
    },
  },
}
